import { HomeFaqHK } from "./HomeFaqHK";
import { HomePricingHK } from "./HomePricingHK";
import { HomeValueShowcase } from "./HomeValueShowcase";
import { HomeWhyClawEase } from "./HomeWhyClawEase";
import { HongKongFooter } from "./HongKongFooter";

export function HongKongHomeSections() {
  return <>
    <section id="how" className="ce-hk-section ce-hk-how">
      <div className="ce-hk-section-inner ce-hk-how-head">
        <h2>ClawEase 能為你帶來什麼？</h2>
        <p className="ce-hk-section-lede">由第一個查詢開始，為你的團隊節省時間、接住更多生意。</p>
      </div>
      <HomeValueShowcase />
    </section>
    <section id="why" className="ce-hk-section ce-hk-why">
      <HomeWhyClawEase />
    </section>
    <section id="pricing" className="ce-hk-section ce-hk-pricing">
      <HomePricingHK />
    </section>
    <HomeFaqHK />
    <HongKongFooter />
  </>;
}
